//---------------angular staff---------------
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { GoogleMapsModule } from '@angular/google-maps';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//---------------components------------------
import { FinalizeComponent } from '../shared/components/finalize/finalize.component';
import { FormComponent } from './form/form.component';

//---------------nodules---------------------
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../material.module';
import { ContactFormComponent } from './form/contactForm/contactForm.component';
import { RequestFormComponent } from './form/requestForm/requestForm.component';
import { HeaderComponent } from './form/header/header.component';
import { LoaderModule } from '../shared/components/loader/loader.module';
import { SupprotChatBoxModule } from '../supprot-chat/supprot-chat-box.module';


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    LoaderModule,
    SupprotChatBoxModule
  ],
  declarations: [FormComponent,RequestFormComponent,ContactFormComponent,HeaderComponent],
  exports: [FormComponent]
})
export class SupportFormModule { }
